import { render, staticRenderFns } from "./BackGround.vue?vue&type=template&id=bbcd8eee&"
import script from "./BackGround.vue?vue&type=script&lang=js&"
export * from "./BackGround.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports